import { filter, flatten } from 'lodash';
import get from 'lodash/fp/get';
import head from 'lodash/fp/head';
import compose from 'lodash/fp/compose';
import { parseContent } from 'client/data/cms/content';
import { EditorialSeo } from 'site-modules/editorial/utils/editorial-seo';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getWebpageSchema } from 'client/seo/schemas/webpage';
import { MAX_WIDTH, MAX_HEIGHT, getFullImageUrl } from 'client/utils/image-helpers';
import { getBreadcrumbsFromConfig } from 'site-modules/editorial/utils/breadcrumbs';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { buildAllAuthorsPath, CmsModel } from 'client/data/models/cms';
import { getModelState } from 'client/data/luckdragon/model';

const MAIN_PHOTO_WIDTH = MAX_WIDTH;
const MAIN_PHOTO_HEIGHT = MAX_HEIGHT;

/**
 * Seo object build for research article page
 *
 * @param state
 * @param contentPathInState
 * @param configContentPath
 * @param pathname
 * @return {*}
 */
export function getSeoObject(state, contentPathInState, configContentPath, pathname) {
  const modelState = getModelState(state);
  const { cms } = state;
  const { content } = cms;

  // Content was not loaded because of preload timeout
  if (!content) {
    return {};
  }

  const articleContent = parseContent(content[contentPathInState]);
  const configContent = parseContent(content[configContentPath]);
  const authorContent = parseContent(
    modelState.get(buildAllAuthorsPath({ contentPath: contentPathInState }), CmsModel)?.author
  );
  const authorName = authorContent.metadata('authorName').value();
  const meta = getMeta(articleContent);
  const { title } = meta;

  const seo = new EditorialSeo(parseContent({}), articleContent);
  const articleHeroContent = articleContent.child('hero-content').links();
  const getImage = compose(url => (url ? getFullImageUrl(url, MAIN_PHOTO_WIDTH) : null), get('href'), head);
  const breadcrumbsData = getBreadcrumbsFromConfig(configContent, pathname, articleContent.title);

  return {
    ...meta,
    image: {
      url: getImage(articleHeroContent),
      width: MAIN_PHOTO_WIDTH,
      height: MAIN_PHOTO_HEIGHT,
    },
    jsonld: flatten(
      filter([
        getWebpageSchema(title),
        getBreadcrumbSchema(breadcrumbsData),
        seo.getPhotoCarouselJsonLd(),
        seo.getPhotoBlocksSchema(),
        seo.getVideoBlocksSchema(),
        seo.getArticlePageSchema(authorName),
        ...seo.getSchemasFromContent(),
      ])
    ),
  };
}
